<template>
  <div
    class="card card-body border-start border-start-width-2 border-start-primary"
  >
    <div class="row">
      <div class="col-12 col-md-6">
        <p><strong>Identificador: </strong>{{ moviment.id }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Número: </strong>{{ moviment.numero }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>CNPJ: </strong>{{ moviment.cnpj }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Contratado: </strong>{{ moviment.fornecedor }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Data do Orçamento: </strong>
          {{ dateTimeRmToDateBR(moviment.dataOrcamento) }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Data da Requisição: </strong>
          {{ dateTimeRmToDateBR(moviment.dataRequisicao) }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Data de Emissão: </strong>
          {{ dateTimeRmToDateBR(moviment.dataEmissao) }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Data de Entrega: </strong>
          {{ dateTimeRmToDateBR(moviment.dataEntrega) }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Centro de Custo: </strong>{{ moviment.centroDeCusto }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Classificação Financeira: </strong>
          {{ moviment.classificacaoFinanceira }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Cod. Orçamento: </strong>{{ moviment.codOrc }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Condição de Pagamento: </strong>
          {{ moviment.condicaoPagamento }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Modalidade: </strong>{{ moviment.modalidade }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Natureza do Orçamento: </strong>
          {{ moviment.naturezaOrcamento }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Origem: </strong>{{ moviment.origem }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Valor da Requisição: </strong>
          {{ formatToCurrencyBr(moviment.valorRequisicao) }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Saldo da Requisição: </strong>
          {{ formatToCurrencyBr(moviment.valorSaldoRequisicao) }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Id Fluig: </strong>{{ moviment.IDFLUIG }}</p>
      </div>
      <div class="col-12">
        <p class="mb-0">
          <strong>Observação: </strong> {{ moviment.observacao }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatToCurrencyBr } from '@/utils/currency'
import { dateTimeRmToDateBR } from '@/utils/date'

export default {
  name: 'DetailsMoviment',

  props: {
    moviment: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formatToCurrencyBr,
      dateTimeRmToDateBR,
    }
  },
}
</script>
